module.exports = __webpack_public_path__ + "img/image44.5055628a.png";